import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../lib/api';

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchSettings = useCallback(async () => {
    try {
      const { data } = await api.get('/settings');
      setSettings(data);
    } catch (e) {
      console.error('Failed to load site settings', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchSettings(); }, [fetchSettings]);

  return (
    <SiteContext.Provider value={{ settings, loading, refresh: fetchSettings }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext) || { settings: null, loading: true };
